import { EProductType } from '@leedpulse-monorepo/enums';
import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { Authentication } from '@leedpulse-monorepo/classes';

async function searchPlansAlgolia(
  searchQuery: string,
  pageToFetch: number,
  hitsPerPage: number,
  auth: Authentication,
  // Optional params
  product?: EProductType,
  active?: boolean,
  archived?: boolean,
): Promise<{ hits: Record<string, unknown>[]; nbHits: number; page: number }> {
  try {
    const params = new URLSearchParams({
      q: searchQuery,
      page: String(pageToFetch),
      hitsPerPage: String(hitsPerPage),
    });
    if (product) params.set('product', product);
    if (active) params.set('active', active ? 'true' : 'false');
    if (archived !== undefined) params.set('archived', archived ? 'true' : 'false');

    const json = await HttpClient.get(
      `/algolia/search/backoffice/plans?${params.toString()}`,
      auth.token
    );

    return {
      hits: json.hits,
      nbHits: json.nbHits,
      page: pageToFetch,
    };
  } catch (e) {
    console.error('[Algolia] plans search error:', e);
    throw new SearchPlansAlgoliaFailure();
  }
}

export class SearchPlansAlgoliaFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default searchPlansAlgolia;